module.exports = __webpack_public_path__ + "img/step-img.34275038.jpg";